// Entrada a "Partidos abiertos" desde la ficha de un club (ClubDetailMobile / ClubDetailDesktop).
// El botón aparece siempre que el club tenga la función habilitada (`club.openMatches.enabled`, que el back
// expone en la ficha pública desde T10), así se puede crear el primer partido. Se consulta el listado del
// club (limit 1, solo se usa `total`) para mostrar el contador cuando hay partidos; si esa consulta falla el
// botón sigue visible, sin contador. Con la función apagada no se muestra ni se consulta nada.
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getOpenMatchesApi } from "../../../api/api";
import RIcon from "../../reservas/components/ReservasIcons";
import { normalizeOpenMatches } from "../openMatchesModel";

const ClubOpenMatchesButton = ({ clubId, enabled = false, className = "r-btn-soft", style }) => {
	const navigate = useNavigate();
	const [total, setTotal] = useState(0);

	useEffect(() => {
		let active = true;
		if (!clubId || !enabled) return undefined;
		(async () => {
			try {
				const res = await getOpenMatchesApi({ clubId, limit: 1 });
				if (active) setTotal(normalizeOpenMatches(res).total);
			} catch (_) {
				if (active) setTotal(0);
			}
		})();
		return () => {
			active = false;
		};
	}, [clubId, enabled]);

	if (!enabled) return null;

	return (
		<button
			type="button"
			className={className}
			style={{ width: "100%", justifyContent: "center", ...style }}
			onClick={() => navigate(`/canchas/${clubId}/partidos`)}
		>
			<RIcon name="user" width={16} height={16} />
			Partidos abiertos
			{total > 0 && (
				<span className="new-badge" style={{ background: "var(--zoco-lime-tint)", borderRadius: 999, padding: "2px 8px", fontSize: 12 }}>
					{total}
				</span>
			)}
		</button>
	);
};

export default ClubOpenMatchesButton;
